import { setupNav } from './modules/menu.js';
import { renderMenu, renderRefinementList, renderInfiniteHits  } from './modules/search.js';
import { setupButtons } from './modules/accessibility.js';

setupNav();
setupButtons();

void (function (root, factory) {
    if (typeof define === 'function' && define.amd) define(factory)
    else if (typeof exports === 'object') module.exports = factory()
    else factory()
}(this, function () {
    var DETAILS = 'details'
    var SUMMARY = 'summary'

    var supported = checkSupport()
    if (supported) return

    // Add a classname
    document.documentElement.className += ' no-details'

    window.addEventListener('click', clickHandler)

    injectStyle('details-polyfill-style',
        'html.no-details ' + DETAILS + ':not([open]) > :not(' + SUMMARY + ') { display: none; }\n' +
        'html.no-details ' + DETAILS + ' > ' + SUMMARY + ':before { content: "\u25b6"; display: inline-block; font-size: .8em; width: 1.5em; }\n' +
        'html.no-details ' + DETAILS + '[open] > ' + SUMMARY + ':before { content: "\u25bc"; }')

    /*
     * Click handler for `<summary>` tags
     */

    function clickHandler (e) {
        if (e.target.nodeName.toLowerCase() === 'summary') {
            var details = e.target.parentNode
            if (!details) return

            if (details.getAttribute('open')) {
                details.open = false
                details.removeAttribute('open')
            } else {
                details.open = true
                details.setAttribute('open', 'open')
            }
        }
    }

    /*
     * Checks for support for `<details>`
     */

    function checkSupport () {
        var el = document.createElement(DETAILS)
        if (!('open' in el)) return false

        el.innerHTML = '<' + SUMMARY + '>a</' + SUMMARY + '>b'
        document.body.appendChild(el)

        var diff = el.offsetHeight
        el.open = true
        var result = (diff != el.offsetHeight)

        document.body.removeChild(el)
        return result
    }

    /*
     * Injects styles (idempotent)
     */

    function injectStyle (id, style) {
        if (document.getElementById(id)) return

        var el = document.createElement('style')
        el.id = id
        el.innerHTML = style

        document.getElementsByTagName('head')[0].appendChild(el)
    }
})); // eslint-disable-line semi

const allSearchContainers = document.querySelectorAll( '.searchable' );
for ( var i = 0; i < allSearchContainers.length; i++ ) {
    const container = allSearchContainers[i];

    // Toggle menu
    const refinement_toggle = document.querySelector('#' + container.id + '-refinement-toggle');

    // The div inside the toggle menu
    const refinement_area = document.querySelector('#' + container.id + '-refinement-area');

    if( refinement_toggle ) {
        refinement_toggle.addEventListener('click', event => {
            event.preventDefault();
            refinement_area.hidden = !refinement_area.hidden;
            const btn = event.target.closest('button');
            btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });
    }

    const searchClient = algoliasearch('2FSGEW6XD0', 'db08b8d3da0862f99f6f41f426bd09d2');
    const search = instantsearch({ indexName: container.getAttribute('data-index'), searchClient });
    const customHits = instantsearch.connectors.connectInfiniteHits( renderInfiniteHits );
    const customMenu = instantsearch.connectors.connectMenu( renderMenu );
    const customRefinementList = instantsearch.connectors.connectMenu(renderRefinementList);

    let filter = '';
    if( container.getAttribute('data-filter') != '' ) {
        filter = 'type:' + container.getAttribute('data-filter');
    }

    search.addWidgets([
        instantsearch.widgets.configure({ hitsPerPage: container.getAttribute('data-count'), filters: filter }),
        instantsearch.widgets.searchBox({
            container: container,
            showSubmit: false,
            showReset: false,
            placeholder: 'Search'
        }),

        customHits({ container: '#' + container.id + '-search-results', moreContainer: '#' + container.id + '-search-more', renderFunction: 'renderHits_' + container.id }),
        customMenu({
            container: '#' + container.id + '-list-filter',
            attribute: 'area_alpha',
            sortBy: ['name:asc'],
            showMore: false
        })
    ]);

    if( refinement_toggle ) {
        search.addWidgets([
            customRefinementList({
                container: refinement_area,
                attribute: 'areas',
                sortBy: ['name:asc'],
                limit: 100
            })
        ]);
    }

    search.start();
}